import { ErrorMessagingModel } from 'models';

import { PropertyInfoOffersBexFeatures } from '__generated__/api';

import ErrorMessage = PropertyInfoOffersBexFeatures.ErrorMessage;

export function adaptErrorMessageModel(errorMessagingModel: ErrorMessage): ErrorMessagingModel {
  if (errorMessagingModel?.title?.text && hasAction(errorMessagingModel.action)) {
    return {
      staticMessage: errorMessagingModel.title.text,
      actionableMessage: errorMessagingModel.action.primary.text,
      actionLink: errorMessagingModel.action.primary.linkUrl,
    } as ErrorMessagingModel;
  }

  return null;
}

export function adaptErrorMessage(errorMessagingModel: ErrorMessage): string {
  if (errorMessagingModel?.title?.text && !hasAction(errorMessagingModel.action)) {
    return errorMessagingModel?.title?.text;
  }

  return null;
}

function hasAction(action?: PropertyInfoOffersBexFeatures.Action): boolean {
  return Boolean(action?.primary?.linkUrl && action?.primary?.text);
}
